var symphony = symphony || {};

;
(function () {

    symphony.registerEvents = function () {

        $('a[href*="#"]:not([href*="#!/donation"])').click(function (e) {
            var target = e.target;
            if (target.type != 'a') {
                if ($(target).parents('a').length > 0) {
                    target = $(target).parents('a')[0];
                }
            }
            if ($(target).attr('href').indexOf('#whatwedo') > -1 || $(target).attr('href').indexOf('#howwehelp') > -1) {
                if ($('#what-we-do').length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    goThere($('#what-we-do'));
                }
            } else {
                var element = $("[data-id=" + $(target).attr('href').split('#')[1] + "]");
                // make sure the link is on this page before scrolling down to it
                var pageUrl = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
                if (pageUrl == "") {
                    pageUrl = "home";
                }
                if (($(target).attr('href').indexOf(siteUrlAlias + '/' + pageUrl) > -1 || $(target).attr('href').indexOf('#') == 0) && element.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    goThere(element);
                }
            }
        });

        if ((window.location.hash == "#whatwedo" || window.location.hash == "#howwehelp") && $('#what-we-do').length > 0) {
            setTimeout(function () {
                goThere($('#what-we-do'));
            }, 300);
        } else if (window.location.hash.length > 0) {
            var element = $("[data-id=" + window.location.hash.replace('#', '') + "]");

            if (element.length > 0) {
                if (element.hasClass('tab')) {
                    $(element).find("input").click();
                } else {
                    goThere(element);
                }
            }
        }

        function goThere($elm) {
            if (!$('body').hasClass('kroc-theme')) {
                $('body').addClass('header-isSticky');
                $('body').addClass('givingToolbar-isSticky');
            }
            setTimeout(function () {
                symphony.site.animateScrollTo($elm);
            }, 350);
        }

        function setQaUrls() {
            var qaHosts = ["md1", "md1:8080", "md1secure", "md1secure:8443", "mdqa.salvationarmy.org"];
            var isQA = qaHosts.indexOf(location.host) > -1 || conductorUrlAlias == "dn_conductor";
            if (isQA) {
                $('a[href^="' + fullSiteDomain + '"]').each(function () {
                    if ($(this).attr('href')) {
                        $(this).attr('href', $(this).attr('href').replace(fullSiteDomain, window.location.protocol + '//' + window.location.host + '/' + siteUrlAlias));
                    }
                });
                $('a[href^="https://' + thqSubdomain + '.salvationarmy.org/' + thqUrlAlias + '"]').each(function () {
                    if ($(this).attr('href')) {
                        $(this).attr('href', $(this).attr('href').replace("https://" + thqSubdomain + ".salvationarmy.org/" + thqUrlAlias, window.location.protocol + '//' + window.location.host + '/' + thqUrlAlias));
                    }
                });
                $('a[href="https://' + thqSubdomain + '.salvationarmy.org"],a[href="https://' + thqSubdomain + '.salvationarmy.org/"]').each(function () {
                    if ($(this).attr('href')) {
                        $(this).attr('href', $(this).attr('href').replace("https://" + thqSubdomain + ".salvationarmy.org", window.location.protocol + '//' + window.location.host + '/' + thqUrlAlias));
                    }
                });
                $('a[href^="https://' + thqSubdomain + '.salvationarmy.org/"]').each(function () {
                    if ($(this).attr('href')) {
                        $(this).attr('href', $(this).attr('href').replace("https://" + thqSubdomain + ".salvationarmy.org", window.location.protocol + '//' + window.location.host));
                    }
                });
            }
        }

        function openExternalLinksInNewTab() {
            $('a').each(function () {
                if (
                    $(this).attr('href') &&
                    $(this).attr('href').indexOf('javascript') == -1 &&
                    $(this).attr('href').indexOf('tel:') == -1 &&
                    $(this).attr('href').indexOf('?') != 0 &&
                    $(this).attr('href').indexOf('/' + siteUrlAlias) != 0 &&
                    $(this).attr('href').indexOf('/' + siteUrlAlias + '/') == -1 &&
                    $(this).attr('href').indexOf(fullSiteDomain.replace('https://', '').replace('http://', '').replace('www.', '').replace('/' + siteUrlAlias, '')) == -1
                ) {
                    $(this).attr('target', '_blank');
                }
            });
        }

        if ($('.admin-body').length == 0) {
            openExternalLinksInNewTab();
            setQaUrls();
        }

        symphony.replaceProperties();
    };

    symphony.replacePropertiesCount = 0;
    symphony.replaceProperties = function () {
        if (typeof symphony.config.properties != "undefined" && symphony.config.properties != null) {
            if ($('div:contains("NO_PROPERTY_FOUND")').length > 0) {
                $('div:contains("NO_PROPERTY_FOUND")').each(function (i, elm) {
                    var propertyName = $(elm).text().split("NO_PROPERTY_FOUND ('")[1].split("'")[0].trim();
                    var stringToReplace = "NO_PROPERTY_FOUND ('" + propertyName + "')";
                    symphony.replacePropertyHtml(elm, stringToReplace, propertyName);
                });
            }
            if ($('div:contains("!!!!!PROPERTY[")').length > 0) {
                $('div:contains("!!!!!PROPERTY[")').each(function (i, elm) {
                    var propertyName = $(elm).text().split("!!!!!PROPERTY[")[1].split("]")[0].trim();
                    var stringToReplace = "!!!!!PROPERTY[" + propertyName + "]!!!!!";
                    symphony.replacePropertyHtml(elm, stringToReplace, propertyName);
                });
            }
        } else {
            setTimeout(function () {
                if (symphony.replacePropertiesCount < 60) {
                    symphony.replacePropertiesCount++;
                    symphony.replaceProperties();
                }
            }, 200);
        }
    };
    symphony.replacePropertyHtml = function (elm, stringToReplace, propertyName) {
        if (propertyName == "ministriesGrid") {
            propertyName = "ministries";
        }
        var template = symphony.templates['property-' + propertyName];
        var propertyObject = $.grep(symphony.config.properties, function (p) {
            return p.name == propertyName;
        })[0];
        if (typeof propertyObject != "undefined" && propertyObject != null && typeof propertyObject.value != "undefined" && propertyObject.value != null) {
            var propertyData = typeof propertyObject.value == "string" ? JSON.parse(propertyObject.value) : propertyObject.value;
            if (typeof template != "undefined") {
                var newHtml = $(elm).html().replace(stringToReplace, template({
                    "property": propertyData
                }));
                $(elm).html(newHtml);
            }
        }
    };


})();
